jQuery(document).ready(function () {

  //Popup newsletter
  jQuery('.shadow').click(function (e) {
    jQuery('.shadow').hide();
    jQuery('.newsletter').removeClass('fixed-box');
    // jQuery('header.site-header #mega-menu-wrap-primary #mega-menu-primary').removeClass('flex');
    jQuery('nav#site-navigation').removeClass('shown');
    // jQuery('#site-navigation.main-navigation').css('display','none');
  });

  jQuery('.newsletter-button a').click(function (event) {
    event.preventDefault();
    jQuery('.newsletter').addClass('fixed-box');
    jQuery('.fixed-box').show();
    jQuery('.shadow').show();
  });


  jQuery('.search-field').attr("autocomplete", "off");
  jQuery(function () {
    var $button = jQuery('.mega-menu-item-6113 > .mega-sub-menu').clone();
    $button.addClass('mega-menu-clone')
    jQuery('.less-sugar-box-home').append($button);
  });


  // Input poids utilisteur

  var value = jQuery('#weight').attr('value');
  jQuery('.weight_less').click(function () {
    value = value - 1;
    jQuery('#weight').attr('value', value);
  });

  jQuery('.weight_more').click(function () {
    value++;
    jQuery('#weight').attr('value', value);
  });

  function storageAvailable(type) {
    try {
      var storage = window[type],
        x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return false;
    }
  }

  function openPopup(url, title, width, height) {
    var left = (screen.width / 2) - (width / 2);
    var top = (screen.height / 2) - (height / 2);
    window.open(url, title, 'height=' + height + ', width=' + width + ', left=' + left + ', top=' + top + ', toolbar=no, menubar=yes, location=no, resizable=yes, scrollbars=no, status=no');
  }

  (function ($) {

    //Share btns 
    var shareArticleBtn = $('.share_article_btn');
    $('.partager-test').parent().append(shareArticleBtn);
    var toggleSocial = false;
    $('.partager-test a').click(function (e) {
      e.preventDefault();
      if (!toggleSocial) {
        $('.share_article_btn').css('opacity', '1');
        $('.share_article_btn').css('height', 'initial');
        toggleSocial = true;
      } else {
        $('.share_article_btn').css('opacity', '0');
        $('.share_article_btn').css('height', '0');
        toggleSocial = false;
      }
    });

    function isMainEdulcorants() {
      if ($('body').is(".parent-pageid-131") ||
        $('body').is(".parent-pageid-6214") ||
        $('body').is(".parent-pageid-6220") ||
        $('body').is(".parent-pageid-6223") ||
        $('body').is(".parent-pageid-6226") ||
        $('body').is(".parent-pageid-6230")
      ) {
        var $button = jQuery('.mega-menu-item-6113 > .mega-sub-menu').clone();
        $button.addClass("mega-menu-clone");
        jQuery('#masthead').after($button);


      } else if (
        $('body').is(".parent-pageid-675") ||
        $('body').is(".parent-pageid-6215") ||
        $('body').is(".parent-pageid-6221") ||
        $('body').is(".parent-pageid-6224") ||
        $('body').is(".parent-pageid-6227") ||
        $('body').is(".parent-pageid-6231")
      ) {
        var $button = jQuery('.mega-menu-item-7159 > .mega-sub-menu').clone();
        $button.addClass("mega-menu-clone");
        jQuery('#masthead').after($button);
      };


      if ($('.site-main > article').is("#post-131") || $('article').is("#post-675")) {
        if ($('.site-main > article').is("#post-131")) {
          var $button = jQuery('.mega-menu-item-6113 > .mega-sub-menu').clone();
        } else {
          var $button = jQuery('.mega-menu-item-7159 > .mega-sub-menu').clone();
        }
        $button.addClass("mega-menu-clone");
        jQuery('.post-thumbnail').css('display', 'none');
        jQuery('.entry-header').after($button);
        console.log('batch');
        console.log($button)
      }
    }

    isMainEdulcorants();

    // function subEdulcorants() {
    //     var $cat = $('.site-main > input').val();
    //     console.log($cat);

    //     var $button2 = jQuery('.mega-menu-item-6113 > .mega-sub-menu').clone();
    //     $button2.addClass($cat);
    //     jQuery('header').after($button2);
    // }

    // subEdulcorants();

    reClamp();

    function reClamp() {
      $('body.archive #main article .entry-content p, #articles_lies article .entry-content p').each(function (index, element) {
        $clamp(element, {
          clamp: 5
        });
      });
    }

    $('body').on('post-load', function () {
      reClamp()
    });

    /**
     * Gestion du menu sur smartphone
     */
    $('.main-navigation').on('touchstart mouseenter focus', 'a', function (e) {
      if (e.type == 'touchstart') {
        e.stopImmediatePropagation();

        // S'il y a un sous-menu
        if ($(this).next('.sub-menu').length) {
          if (!$(this).hasClass('open')) {
            $('.main-navigation a.open').removeClass('open');
            $(this).addClass('open');
            e.preventDefault();
          }
        }
      }
    });

    var subMenu = false;
    $('#mega-menu-item-6113 > a').click(function (e) {
      e.preventDefault();
      if (!subMenu) {
        $('#mega-menu-item-6113 > ul').css('display', 'block');
        $('#mega-menu-item-6113 > ul > li').css('display', 'block');
        $('#mega-menu-item-6113 > ul > li > ul').css('display', 'block');
        subMenu = true;
      } else {
        $('#mega-menu-item-6113 > ul').css('display', 'none');
        $('#mega-menu-item-6113 > ul > li').css('display', 'none');
        $('#mega-menu-item-6113 > ul > li > ul').css('display', 'none');
        subMenu = false;
      }
    });

    /**
     * Sticky header
     */
    if (!$('body').hasClass('mobile')) {
      $(window).scroll(function () {
        if ($(document).scrollTop() > 0)
          $('body').addClass('fixed_header');
        else
          $('body').removeClass('fixed_header');
      });
    }

    // Ajustement automatique des vidéos
    var $allVideos = $('iframe[src^="http://player.vimeo.com"], iframe[src^="https://www.youtube.com"], object, embed');

    $allVideos.each(function () {
      // jQuery .data does not work on object/embed elements
      $(this).attr('data-aspectRatio', this.height / this.width).removeAttr('height').removeAttr('width');
    });

    $(window).resize(function () {
      $allVideos.each(function () {
        var $el = $(this),
          newWidth = $el.parent().width();
        $el.width(newWidth).height(newWidth * $el.attr('data-aspectRatio'));
      });
    }).resize();

    /**
     * Frontpage
     */
    if ($('.main-article .flexslider').length)
      $('.main-article .flexslider').flexslider({
        controlNav: false,
        directionNav: false,
        slideshowSpeed: 6000,
        animationSpeed: 500
      });

    /**
     * Widgets
     */

    // Newsletter
    var timer;
    if (document.cookie.indexOf('visited=true') === -1) {
      timer = setTimeout(openNewsletter, edulcorants.delai_popup_newsletter * 1000);
    }
    $('body').on('click', '.widget_edu_newsletter_widget', function () {
      openNewsletter();
    });

    function openNewsletter() {
      var expires = new Date();
      expires.setDate(expires.getDate() + parseInt(edulcorants.duree_cookie_popup_newsletter));
      document.cookie = "visited=true; expires=" + expires.toUTCString();

      clearTimeout(timer);
      jQuery('.newsletter').addClass('fixed-box');
      jQuery('.fixed-box').show();
      jQuery('.shadow').show();
    }

    $('form#form_newsletter').submit(function (e) {
      e.preventDefault();
      var input_name = $('#form_newsletter input[name="name"]'),
        input_email = $('#form_newsletter input[name="email"]'),
        input_group = $('#form_newsletter select[name="group"]'),
        reg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      $('#form_newsletter .field-error').remove();
      $('#form_newsletter input.error').removeClass('error');
      $('#form_newsletter button').append('<div class="loader"></div>');
      $("#form_newsletter button").attr("disabled", true);

      if (input_name.val() == '')
        input_name.addClass('error').parent().append('<i class="field-error">' + edulcorants.required_field + '</i>');

      if (input_group.val() === null)
        input_group.addClass('error').parent().append('<i class="field-error">' + edulcorants.required_field + '</i>');

      if (input_email.val() == '')
        input_email.addClass('error').parent().append('<i class="field-error">' + edulcorants.required_field + '</i>');
      else if (!reg.test(input_email.val()))
        input_email.addClass('error').parent().append('<i class="field-error">' + edulcorants.invalid_email + '</i>');

      if ($('#form_newsletter .field-error').length) {
        $('#form_newsletter button').find('.loader').remove();
        $("#form_newsletter button").attr("disabled", false);

        return false;
      }

      $.ajax({
        type: 'POST',
        url: edulcorants.ajax_url,
        data: {
          action: 'submit_newsletter',
          data: $('#form_newsletter').serialize()
        }
      }).done(function(response) {
        let data = JSON.parse(response);

        if (data.success) {
          var expires = new Date();
          expires.setDate(expires.getDate() + 9999);
          document.cookie = "visited=true; expires=" + expires.toUTCString();

          window.location.href = data.redirect_to;
        }

        if (data.status == 'already_subscribed') {
          $('#form_newsletter').append('<p class="field-error already-sub">' + data.message +'</p>');
        }

        $('#form_newsletter button').find('.loader').remove();
        $("#form_newsletter button").attr("disabled", false);
      });
    });

    // Quizz
    var quizz_question_num = 1,
      quizz_score = 0;

    $('.widget_edu_quizz_widget').on('click', '#reponses a', function () {
      event.stopPropagation();
      $('.widget_edu_quizz_widget #question ul > li > a').addClass('grey-border');
      if ($('#infos_resultats:visible').length) return false;

      $('.widget_edu_quizz_widget #question').addClass('loading');

      var question_id = $('#reponses').data('id'),
        reponse_id = $(this).data('id');

      $.getJSON(
        edulcorants.ajax_url, {
          action: 'quizz_reponse',
          question_id: question_id,
          reponse_id: reponse_id,
          lang: edulcorants.current_language,
          unique: (localStorage.quizz == undefined),
        },
        function (data) {
          $.each(data.reponses, function (index, reponse) {
            if (reponse.correcte) $('#reponses a[data-id="' + index + '"] span.bar').addClass('correcte');

            var pourcentage = Math.round(100 * parseInt(reponse.reponses) / data.total);
            if (isNaN(pourcentage)) pourcentage = 0;

            $('#reponses a[data-id="' + index + '"] span.label').append(' (' + pourcentage + '%)');
            $('#reponses a[data-id="' + index + '"] span.bar').animate({
              width: pourcentage + '%'
            }, 1000);
          });
          (function ($) {
            $.fn.googleScript = function () {
              dataLayer.push({
                'answer': data.answer, //dynamique (true or false)
                'QuestionID': data.questionID, //dynamique
                'event': 'Test_knowledge'
              });
              return this;
            };
          })(jQuery);

          if (quizz_question_num >= 10) {
            $('#question_suivante').hide();
            $('#voir_resultat').css('display', 'inline-block');
          }

          // Etoiles
          $('.widget_edu_quizz_widget .stars div:nth-child(' + quizz_question_num + ')').addClass(data.answer ? 'ok' : 'notok');
          quizz_question_num++;

          // Score
          if (data.answer) {
            quizz_score++;
            $('.widget_edu_quizz_widget #resultats h5 > span > span').text(quizz_score);
          }

          $('#infos_resultats').fadeIn();

          $('#infos_reponse h5').text(data.message);
          $('#infos_reponse div').html(data.explication);

          if (data.lien)
            $('#reponse_lien').attr('href', data.lien).show();
          else
            $('#reponse_lien').hide();

          $('#infos_reponse').slideDown();

          $('.widget_edu_quizz_widget #question').removeClass('loading');

          $('#infos_reponse').googleScript();
        }
      );

      localStorage.quizz = true;

      return false;
    });
    $('.widget_edu_quizz_widget').on('click', '#question_suivante', function () {
      $('.widget_edu_quizz_widget #question ul > li > a').removeClass('grey-border');
      $('#infos_reponse').slideUp();
      $('.widget_edu_quizz_widget #question').addClass('loading');

      var question_id = $('#reponses').data('id');

      $.get(
        edulcorants.ajax_url, {
          action: 'quizz_nouvelle_question',
          question_id: question_id,
          lang: edulcorants.current_lang
        },
        function (data) {
          $('#question').fadeOut(400, function () {
            $('#question').html(data).fadeIn(400, function () {
              $('.widget_edu_quizz_widget #question').removeClass('loading');
            });
          });
        }
      );
      return false;
    });
    $('.widget_edu_quizz_widget').on('click', '#voir_resultat', function () {
      $('.widget_edu_quizz_widget #question ul > li > a').removeClass('grey-border');
      $('#question, #infos_reponse').slideUp();
      $('#resultats').slideDown();

      return false;
    });
    $('.widget_edu_quizz_widget').on('click', '#rejouer', function () {
      $('.widget_edu_quizz_widget #question ul > li > a').removeClass('grey-border');
      resetQuizz();

      return false;
    });


    // Re-init du formulaire
    function resetQuizz() {
      quizz_question_num = 1;
      quizz_score = 0;

      $('.widget_edu_quizz_widget h4 .stars div').removeClass('ok notok');
      $('#question').slideDown();
      $('#resultats').slideUp();

      $('#question_suivante').show();
      $('#voir_resultat').hide();

      $('.widget_edu_quizz_widget #question_suivante').trigger('click');
    }

    $('body:not(.mobile)').on('click', '.new_search', function () {
      $('.search-field').focus();
      return false;
    });

    /**
     * Contact
     */
    $('body .frm_forms').on('change', '.horizontal_radio input', function () {
      if ($(this).attr('checked'))
        $(this).parent().addClass('checked');
      else
        $(this).parent().removeClass('checked');
    });
    $('body .frm_forms').on('click', 'a.submit-button', function () {
      $(':submit', $(this).parent()).trigger('click');
      return false;
    });

    /**
     * Popup message
     */
    var timer_popup;
    if (document.cookie.indexOf('visited2=true') === -1 && $('#popup_content').length) {
      timer_popup = setTimeout(openPopup, edulcorants.delai_popup_message * 1000);
    }

    function openPopup() {
      var expires = new Date();
      expires.setDate(expires.getDate() + parseInt(edulcorants.duree_cookie_popup_message));
      document.cookie = "visited2=true; expires=" + expires.toUTCString();

      clearTimeout(timer_popup);
      $.colorbox({
        inline: true,
        href: '#popup_content',
        fixed: true,
        maxWidth: '95%',
        maxHeight: '95%'
      });
    }

    /**
     * Gestion du cookies disclaimer
     */
    cookieDisclaimer();

    function cookieDisclaimer() {
      if (storageAvailable('localStorage')) {
        var today = new Date(),
          cookies_disclaimer_expires = new Date(localStorage.cookies_disclaimer_expires);

        if (localStorage.cookies_disclaimer == undefined || today.getTime() > cookies_disclaimer_expires.getTime()) {
          $('#cookies_disclaimer').fadeIn();

          localStorage.cookies_disclaimer = true;

          var expires = new Date();
          expires.setDate(expires.getDate() + 365);
          localStorage.cookies_disclaimer_expires = expires.toUTCString();
        }
      }

      $('#cookies_disclaimer').on('click', '.close', function () {
        $('#cookies_disclaimer').fadeOut();
      });
    }

    /**
     * Edulcotest
     */
    $('#edulcotest').on('click', '#add_product', function () {
      $('#edulcotest_family option[value=0]').prop('selected', true);
      $('#edulcotest_product').html('<option value="0">' + edulcorants.select + '</option>');
      $('#edulcotest_add #quantity').val('');
      $('#hide_test').show("slow");

    });

    $('#weight').keyup(function () {
      onlyNumbers(this);
      recalc_edulcorants();
    });

    $('#edulcotest_add #quantity').keyup(function () {
      onlyNumbers(this);
    });

    var unit,
      dja_aspartame = 40,
      dja_acesulfame = 9,
      dja_cyclamate = 7,
      dja_saccharine = 5,
      dja_sucralose = 15,
      dja_stevia = 4;

    $('#edulcotest_add').on('change', '#edulcotest_family', function () {
      unit = $('#edulcotest_family option[value=' + $('#edulcotest_family').val() + ']').data('unit');
      $('span#unit').html('(' + unit + ')');

      $('#edulcotest_product').prop('disabled', 'disabled');

      $.get(
        edulcorants.ajax_url, {
          action: 'edulcotest_products',
          family_id: $('#edulcotest_family').val(),
          lang: edulcorants.current_lang
        },
        function (data) {
          $('#edulcotest_product').html(data);
          $('#edulcotest_product').prop('disabled', false);
        }
      );
    });

    $('#edulcotest_add').on('click', 'a.button', function () {
      $('#edulcotest_add .field-error').remove();

      if ($('#edulcotest_product').val() == '0')
        $('#edulcotest_add #edulcotest_product').addClass('error').parent().append('<i class="field-error">' + edulcorants.required_field + '</i>');

      if ($('#edulcotest_add #quantity').val() == '')
        $('#edulcotest_add #quantity').addClass('error').parent().append('<i class="field-error">' + edulcorants.required_field + '</i>');

      if ($('#edulcotest_add .field-error').length)
        return false;

      var product = $('#edulcotest_product option[value=' + $('#edulcotest_product').val() + ']');

      $('#edulcotest #products_list').append(
        '<li data-aspartame="' + product.data('aspartame') + '" ' +
        'data-acesulfame="' + product.data('acesulfame') + '" ' +
        'data-cyclamate="' + product.data('cyclamate') + '" ' +
        'data-saccharine="' + product.data('saccharine') + '" ' +
        'data-sucralose="' + product.data('sucralose') + '" ' +
        'data-stevia="' + product.data('stevia') + '" ' +
        'data-quantity="' + $('#edulcotest_add #quantity').val() + '"> ' +
        product.text() +
        ' (' + $('#edulcotest_add #quantity').val() + ' ' + unit + ')</li>'
      );

      recalc_edulcorants();

      $.colorbox.close();

      return false;

    });

    $('#products_list').on('click', 'li', function () {
      $(this).toggleClass('unchecked');
      recalc_edulcorants();
    });
    $('#edulcotest').on('click', '#reset', function () {
      $('#edulcotest #products_list').html('');
      recalc_edulcorants();
      return false;
    });

    function recalc_edulcorants() {
      let edulcorants = new Array('aspartame', 'acesulfame', 'cyclamate', 'saccharine', 'sucralose', 'stevia'),
        aspartame = 0, acesulfame = 0, cyclamate = 0, saccharine = 0, sucralose = 0, stevia = 0,
        poids = parseInt($('#weight').val()),
        qty_edulcorant = 0,
        qty = 0,
        percent = 0;

      $('#edulcotest #products_list li:not(.unchecked)').each(function () {
        for (let index in edulcorants) {
          qty_edulcorant = parseFloat($(this).data(edulcorants[index]));
          qty = parseInt($(this).data('quantity'));
          if (!isNaN(qty_edulcorant) && !isNaN(qty))
            eval(edulcorants[index] + ' += qty_edulcorant * qty / 100;');
        }
      });

      if (!poids) poids = 1;

      for (let index in edulcorants) {
        eval('qty_edulcorant = ' + edulcorants[index]);
        eval('percent = Math.round( 100 * ' + edulcorants[index] + ' / ( dja_' + edulcorants[index] + ' * poids ) );');
        $('#edulcotest_output li#' + edulcorants[index] + ' .bar').width(percent + '%');
        $('#edulcotest_output li#' + edulcorants[index] + ' .label').text(percent + '%');

        if (qty_edulcorant > 0) {
          $('#edulcotest_output li#' + edulcorants[index]).addClass('fill');
          $('#edulcotest_output li#' + edulcorants[index] + ' .edu_qty').text(Math.round(qty_edulcorant * 100) / 100 + ' mg');
        } else {
          $('#edulcotest_output li#' + edulcorants[index]).removeClass('fill');
          $('#edulcotest_output li#' + edulcorants[index] + ' .edu_qty').text('-');
        }

        if (percent >= 100)
          $('#edulcotest_output li#' + edulcorants[index]).addClass('error');
        else
          $('#edulcotest_output li#' + edulcorants[index]).removeClass('error');
      }

      if ($('#edulcotest_output li.error').length)
        $('.edu_error_responsive').fadeIn();
      else
        $('.edu_error_responsive').fadeOut();
    }

    // Limitation chiffres
    function onlyNumbers(input) {
      var pattern = /[^0-9]/g;
      if (input.value != input.value.replace(pattern, '')) {
        input.value = input.value.replace(pattern, '');
      }
    }

    if ($('article').hasClass('post-6356') ||
      $('article').hasClass('post-6357') ||
      $('article').hasClass('post-6359') ||
      $('article').hasClass('post-212') ||
      $('article').hasClass('post-7859') ||
      $('article').hasClass('post-739')) {
      $('.big-button-icon-container').insertAfter('.entry-content');

      if ($('html').attr('lang') == 'fr-FR') {
        $('.entry-header').append('<div class="read-more">Lire plus</div>');
      } else {
        $('.entry-header').append('<div class="read-more">Lees verder</div>');
      }

      $('.entry-content').css('display', 'none');

      var entryShown = false;
      $('.entry-header').click(function () {
        if (entryShown == false) {
          $('.entry-content').slideDown(function () {
            $([document.documentElement, document.body]).animate({
              scrollTop: $(".post-thumbnail").offset().top
            }, 550);
            $('.post-thumbnail img').addClass('full-height');
          });
          entryShown = true;
        } else {
          $('.entry-content').hide();
          $('.post-thumbnail img').removeClass('full-height');
          entryShown = false
        }
      })
    }

    if ($('body').hasClass('search')) {
      $('.read-more').css('display', 'none');
    }

    // Plus de filtres
    let moreFilters = false;
    $('.autres-filtres-btn').click(function () {
      if (!moreFilters) {
        $('.autres-filtres-btn').text('Moins de filtres');
        $('.autres-filtres').slideDown();
        moreFilters = true;
      } else {
        $('.autres-filtres-btn').text('Plus de filtres');
        $('.autres-filtres').hide();
        moreFilters = false;
      }
    });

    $('.faq-edulcorants').attr('id', 'faq-edulcorants');
    $('.father-child').attr('id', 'faq-sante');
    $('.faq-recettes').attr('id', 'faq-recettes');
    $('.faq-diabete').attr('id', 'faq-diabetes');
    $('.faq-moins-de-sucre').attr('id', 'faq-moins-de-sucre');


    // Déplacement message confirmation
    function frmThemeOverride_frmAfterSubmit(fin, p, errObj, object) {
      (function ($) {
        $('.frm_forms').append($('#message'));
      })(jQuery);
    }

    // AJAX RECETTES
    clickCategory();
    filterCategory();

    $('#filter-recipes').change(function () {
      filterCategory();
    });

    function filterCategory() {
      $('.loadmore-recettes').show()
      var filter = $('#filter-recipes');
      filter.find('button').text('Processing...');
      $.post(
        filter.attr('action'), {
          action: 'recipes_filter',
          value: filter.serialize(),
        },
        function (data) {
          filter.find('button').text('Apply filter');
          $('#list-recipes').html(data);
          clickCategory();
          let maxRecettes = $('#maxRecettes').text();
          $('#maxRecettes').hide()
          if (maxRecettes == 1) {
            $('.loadmore-recettes').hide()
          }
        }
      );
    }


    let loads = 10;
    $('.loadmore-recettes').click(function() {
      loads = loads + 10
      var filter = $('#filter-recipes');
      filter.find('button').text('Processing...');
      $.post(
          filter.attr('action'), {
            nbr: loads,
            action: 'recipes_filter',
            value: filter.serialize(),
          },
          function (data) {
            filter.find('button').text('Apply filter');
            $('#list-recipes').html(data);
            clickCategory();
            var maxRecettes = $('#maxRecettes').text();
            $('#maxRecettes').hide()
            if (maxRecettes == 1) {
              $('.loadmore-recettes').hide()
            }
        }
      );
    })

    function clickCategory() {
      jQuery('.ugb-blog-posts__category-list').on('click', 'a', function () {
        let id = jQuery(this).data('id');
        let categoryBox = jQuery(":checkbox[value='" + id + "']");
        jQuery('input:checkbox').removeAttr('checked');
        jQuery(categoryBox).click();
      });
    }

    jQuery('.type-post.category-recettes .entry-content p a, .type-post.category-recepten .entry-content p a').parent().addClass('wp-block-button is-style-default');


    // The function actually applying the offset
    function offsetAnchor() {
      if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 280);
      }
    }

    // Captures click events of all <a> elements with href starting with #
    jQuery(document).on('click', 'a[href^="#"]', function (event) {
      // Click events are captured before hashchanges. Timeout
      // causes offsetAnchor to be called after the page jump.
      window.setTimeout(function () {
        offsetAnchor();
      }, 0);
    });

    // Set the offset when entering page with hash present in the url
    window.setTimeout(offsetAnchor, 0);


    //Menu recettes sur mobile
    function myFunction(x) {
      if (x.matches) {
        var aside = false;
        jQuery('aside').click(function () {
          if (aside == false) {
            jQuery('aside').css('margin-left', '-2em');
            aside = true;
          } else {
            jQuery('aside').css('margin-left', '-58.5%');
            aside = false;
          }
        });
      }
    }

    var x = window.matchMedia("(max-width: 768px)")
    myFunction(x) // Call listener function at run time
    x.addListener(myFunction)

    jQuery('.burger').click(function () {
      jQuery('nav#site-navigation').addClass('shown');
      jQuery('.shadow').show();
    });


    // Alternative layout for homepage
    jQuery('body').prepend('<input type="checkbox" id="switch" style="opacity : 0.1; position : absolute"/>');
    jQuery('#switch').change(
      function () {
        if (jQuery(this).is(':checked')) {
          jQuery('#infos_reponse').parent().addClass('perspective');
          jQuery('.section-quizz.widget_edu_quizz_widget').addClass('alt-style');
          jQuery('#post-757 .entry-content .ugb-container--align-horizontal-full.block-bordered').addClass('style-alt-test');
        } else {
          jQuery('#infos_reponse').parent().removeClass('perspective');
          jQuery('.section-quizz.widget_edu_quizz_widget').removeClass('alt-style');
          jQuery('#post-757 .entry-content .ugb-container--align-horizontal-full.block-bordered').removeClass('style-alt-test');
        }
      });

  })(jQuery);
});